<div class="c-survey__section survey-question">
    @for (text of questionDetails.QuestionText; track text) {
      <h2 [attr.headerid]="text" class="c-survey__question is-multi-question">{{ text | translate }}</h2>
    }
  </div>

  <div class="c-radio-survey">
    @for (question of questionDetails.Questions; track question) {
      <div class="c-form-radio-group">
        <app-survey-button-multi [attr.questionId]="question.QuestionId" [questionDetails]="question" [surveyData]="surveyData" (answerSelectedEvent)="answerSelected($event)"></app-survey-button-multi>
      </div>
    }
  </div>
